import { memo, useMemo } from "react";

import { cn } from "@/lib/chillnn/cn";

type Props = {
	title: string;
	showChildrenDivider?: boolean;

	children: React.ReactNode;
	descriptionChildren?: React.ReactNode;
};

export const FormIslandSection = memo(({ title, showChildrenDivider = true, children, descriptionChildren }: Props) => {
	const dividerStyle = useMemo(() => showChildrenDivider && "divide-y divide-zinc-100", [showChildrenDivider]);
	return (
		<section className="space-y-2">
			<div className="space-y-1">
				<h3 className="font-semibold">{title}</h3>
				{descriptionChildren}
			</div>

			<div className={cn("rounded-lg border border-zinc-100 bg-white px-3 py-4 lg:px-5 lg:py-6", dividerStyle)}>
				{children}
			</div>
		</section>
	);
});
